import { render, staticRenderFns } from "./DrugExternalLinks.vue?vue&type=template&id=64a70830&scoped=true&lang=pug"
import script from "./DrugExternalLinks.vue?vue&type=script&lang=js"
export * from "./DrugExternalLinks.vue?vue&type=script&lang=js"
import style0 from "./DrugExternalLinks.vue?vue&type=style&index=0&id=64a70830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a70830",
  null
  
)

export default component.exports